var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"top-message"},[_c('van-image',{attrs:{"width":"150","src":require('../../assets/error.svg')}}),_c('div',[_vm._v("请在8:30之前或17:30之后提交数据。")])],1),_c('van-image',{staticClass:"bottom-img",attrs:{"src":require('../../assets/jpg_empty.png')}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }